export const findTranslation = (array: any[], lang: string, defaultLang = 'en') => {
  return (
    array?.find((elem) => elem.language === lang)?.text ??
    array?.find((elem) => elem.language === defaultLang)?.text
  );
};
